import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchSearchAssetModelLimit(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Asset/SearchAssetModelLimit`, {
                        params: {
                            search: queryParams.search,
                            assetModelId: queryParams.assetModelId,
                            limitTypeId: queryParams.limitTypeId,
                            alertTypeId: queryParams.alertTypeId,
                            page: queryParams.page,
                            perPage: queryParams.perPage,
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchAssetModelLimit(ctx, {id}) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Asset/GetAssetModelLimit`, {
                        params: {
                            id
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addAssetModelLimit(ctx, {modelLimitData}) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/v1/Asset/CreateAssetModelLimit', modelLimitData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateAssetModelLimit(ctx, {modelLimitData}) {
            return new Promise((resolve, reject) => {

                axios
                    //.post('/apps/customer/customers', { customer: customerData })
                    .put('/api/v1/Asset/UpdateAssetModelLimit', modelLimitData)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchAlerts(ctx, ) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Asset/GetAllAlertType`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchLimits(ctx, ) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Asset/GetAllLimitType`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        


    },

}
